import { connect } from 'react-redux';
import _get from 'lodash-es/get';
import { openErrorToast } from '../../../../../reducers/uiLogic/index';
import CreatePolicyForm from './CreatePolicyForm';
import { getAllQuestionsInitiate } from '../../../../../actions/questions';
import {
  addOptionInitiate,
  updateOptionInitiate,
} from '../../../../../actions/programs';

const mapStateToProps = state => {
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const companyId = _get(state, 'user.selectedWorkspace.company_id', '');
  const programInfo = _get(state, 'programs.programInfo', {});
  const questions = _get(state, 'questions', {});
  return {
    companyId,
    selectedWorkspace,
    programInfo,
    questions,
    fetchingProgramInfo:
      _get(state, 'apiState.GET_PROGRAM_INFO.isFetching', true) &&
      !_get(state, 'apiState.GET_PROGRAM_INFO.isIdle', false),
    fetchedProgramInfo: _get(state, 'apiState.GET_PROGRAM_INFO.success', true),
  };
};

const mapDispatchToProps = dispatch => ({
  showErrorToast: message => dispatch(openErrorToast(message)),
  getAllQuestions: payload => dispatch(getAllQuestionsInitiate(payload)),
  addOptions: payload => dispatch(addOptionInitiate(payload)),
  updateOption: payload => dispatch(updateOptionInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreatePolicyForm);
